import { ArticleHeading1, Header3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingAdvantagesContainer.css';

export interface INewbuildingAdvantagesContainerProps {
  redesignPage: boolean;
  name: string;
  showHeader?: boolean;
}

export const NewbuildingAdvantagesContainer = ({
  redesignPage,
  children,
  name,
  showHeader = true,
}: React.PropsWithChildren<INewbuildingAdvantagesContainerProps>) => {
  return (
    <div className={styles['container']}>
      {showHeader && redesignPage && (
        <div className={styles['title']}>
          <ArticleHeading1 as="h1" fontWeight="bold">
            О ЖК&nbsp;&laquo;{name}&raquo;
          </ArticleHeading1>
        </div>
      )}

      {showHeader && !redesignPage && (
        <div className={styles['title']}>
          <Header3>О ЖК&nbsp;&laquo;{name}&raquo;</Header3>
        </div>
      )}
      {children}
    </div>
  );
};
